import http from "src/_services/httpService";
import { $BASE_URL } from "src/constants";

const apiEndpoint = `${$BASE_URL}/api/v1/connection`
const apiEndpointInvoice = `${$BASE_URL}/api/v1/invoice`


const createConnection = (payload) => {
    return http.post(apiEndpoint, payload);
}

const getConnections = (params) => {
    return http.get(apiEndpoint, {params});
}

const getConnectionById = (id) => {
    return http.get(`${apiEndpoint}/${id}`);
}

const updateConnection = (payload) => {
    return http.post(`${apiEndpoint}/update`, payload);
}
const getAcceptedConnections = (payload) => {
    return http.get(`${apiEndpoint}/accepted`);
}
const settleBalance = (id, from) => {
    return http.put(`${apiEndpoint}/settle-balance/${id}`);
}

const getExcelReport = (id, email) => {
    let url = `${apiEndpoint}/xlsx/${id}`
    if (email) {
        url += `?email=${email}`
    }
    return http.get(url);
}

const updateConnectionStatus = (payload) => {
    return http.post(`${apiEndpoint}/status`, payload);
}
const getConnectionInvoices = ({id, page}) => {
    return http.get(`${apiEndpointInvoice}/${id}?page=${page}`);
}
const getConnectionInvoicesExcel = (id, email) => {
    return http.get(`${apiEndpointInvoice}/xlsx/${id}?email=${email}`);
}


const ConnectionService = {
    createConnection,
    getConnections,
    getConnectionById,
    updateConnection,
    getAcceptedConnections,
    settleBalance,
    getExcelReport,
    updateConnectionStatus,
    getConnectionInvoices,
    getConnectionInvoicesExcel
};

export default ConnectionService;